// plugins/bootstrap.js
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap";

export default defineNuxtPlugin(() => {});
